// src/components/Dashboard/MainHeader.jsx

import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SvgIcon from "@mui/material/SvgIcon";

const MainHeader = ({ title, component, helpText }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap", // Prevent wrapping
        height: 40, // Fixed height to maintain alignment
      }}
    >
      {/* Icon Component */}
      <SvgIcon sx={{ color: "grey.500", marginRight: 1 }}>
        {component}
      </SvgIcon>

      {/* Title */}
      <Typography
        variant="overline"
        sx={{
          color: "primary.main",
          fontWeight: "bold",
          whiteSpace: "nowrap", // Prevent text wrapping
        }}
      >
        {title}
      </Typography>

      {/* Optional Help Icon */}
      {helpText && (
        <Tooltip title={helpText} arrow>
          <IconButton
            size="small"
            sx={{
              marginLeft: 0.5,
              padding: 0,
              height: "24px",
              width: "24px",
            }}
          >
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

MainHeader.propTypes = {
  title: PropTypes.string.isRequired,
  component: PropTypes.element.isRequired,
  helpText: PropTypes.node, // Accepts JSX for formatted content
};

MainHeader.defaultProps = {
  helpText: null,
};

export default MainHeader;
